export const REALTIME_EVENT = 'REALTIME_EVENT';
export const REALTIME_EVENT_SUCCESS = 'REALTIME_EVENT_SUCCESS';
export const REALTIME_EVENT_ERROR = 'REALTIME_EVENT_ERROR';
export const REALTIME_EVENT_DETAILS = 'REALTIME_EVENT_DETAILS';
export const EVENTS = 'EVENTS';
export const EVENTS_SUCCESS = 'EVENTS_SUCCESS';
export const EVENTS_ERROR = 'EVENTS_ERROR';